/* =============================================================
   FRUTTAIO THEME — Global JS v2
   File: assets/fruttaio-global.js
   ============================================================= */
(function () {
  'use strict';

  /* ── Smooth scroll for anchor links ── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* ── Carousel engine ── */
  window.FR2 = window.FR2 || {};

  FR2.carousels = {};

  FR2.initCarousel = function (id) {
    var wrap   = document.getElementById('fr2-carousel-' + id);
    if (!wrap) return;
    var track  = wrap.querySelector('.fr2-car-track');
    var slides = wrap.querySelectorAll('.fr2-car-slide');
    var dots   = wrap.querySelectorAll('.fr2-car-dot');
    var total  = slides.length;
    var cur    = 0;
    var timer  = null;
    var auto   = parseInt(wrap.getAttribute('data-auto') || '3500', 10);

    function go(n) {
      cur = ((n % total) + total) % total;
      track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === cur); });
    }

    wrap.querySelector('.fr2-car-prev') && wrap.querySelector('.fr2-car-prev').addEventListener('click', function () { go(cur - 1); reset(); });
    wrap.querySelector('.fr2-car-next') && wrap.querySelector('.fr2-car-next').addEventListener('click', function () { go(cur + 1); reset(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); reset(); }); });

    function reset() { clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, auto); }

    if (total > 1) reset();
    FR2.carousels[id] = { go: go };
  };

  /* ── Mobile nav toggle ── */
  var mobileToggle = document.getElementById('fr2-nav-toggle');
  var mobileMenu   = document.getElementById('fr2-nav-mobile');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileMenu.style.display === 'flex';
      mobileMenu.style.display = open ? 'none' : 'flex';
    });
  }

  /* ── Snowflake generator for hero ── */
  FR2.initSnow = function (containerId, count, color) {
    var el = document.getElementById(containerId);
    if (!el) return;
    var chars = ['❄', '❅', '❆', '·'];
    for (var i = 0; i < (count || 18); i++) {
      var s = document.createElement('span');
      s.textContent = chars[Math.floor(Math.random() * chars.length)];
      s.style.cssText = [
        'position:absolute',
        'left:' + (Math.random() * 100) + '%',
        'top:' + (Math.random() * 100) + '%',
        'font-size:' + (8 + Math.random() * 10) + 'px',
        'color:' + (color || 'rgba(26,107,42,.22)'),
        'animation:fr2Drift ' + (5 + Math.random() * 5) + 's ' + (Math.random() * 4) + 's ease-in-out infinite',
        'pointer-events:none',
        'user-select:none'
      ].join(';');
      el.appendChild(s);
    }
  };

  /* ── Auto-init on DOMContentLoaded ── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-fr2-carousel]').forEach(function (el) {
      FR2.initCarousel(el.getAttribute('data-fr2-carousel'));
    });
    var snowEl = document.getElementById('fr2-snow');
    if (snowEl) FR2.initSnow('fr2-snow');
  });

})();
